module.exports = __webpack_public_path__ + "img/Dashboard.1c5a66fc.svg";